import { css, FASTElement, html } from "@microsoft/fast-element";
import { NatGenDesignSystem } from "../../natgen-design-system";
import { display } from "../../foundation/display";
import { getToken } from "../../design-tokens";

// TODO: Generic pill with StartEnd for close button?
export class NatGenListboxPill extends FASTElement {}

export const natgenListboxPillDefinition = NatGenListboxPill.compose({
    name: `${NatGenDesignSystem.prefix}-listbox-pill`,
    template: html<NatGenListboxPill>`
        <slot></slot>
        <natgen-icon name="light/times" size="3"></natgen-icon>
    `,
    styles: css`
        ${display('block')} :host {
            padding: calc(${getToken('space-design-unit')} * 1px);
            background-color: ${getToken('ui-button-filled-color-primary-background-rest')};
            color: ${getToken('ui-button-filled-color-primary-text-rest')};
            font-size: ${getToken('typography-body-x-small-font-size')};
            border-radius: calc(${getToken('space-input-corner-radius')} * 1px);
        }

        natgen-icon {
            margin-inline-start: calc(${getToken('space-design-unit')} * 1px);
            vertical-align: middle;
        }
    `
});
